// SmsSection.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import "./SmsSection.css";
import analyticsService from "../../../services/analyticsService";

function SmsSection() {
  const [smsData, setSmsData] = useState({
    sent: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    clicks: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    purchases: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
    revenue: { today: 0, yesterday: 0, week: 0, month: 0, lastMonth: 0 },
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await analyticsService.getSmsAnalytics();

        if (response.success && response.data) {
          const { smsMetrics, clickMetrics, conversionMetrics, revenueMetrics } = response.data;

          setSmsData({
            sent: {
              today: smsMetrics?.today || 0,
              yesterday: smsMetrics?.yesterday || 0,
              week: smsMetrics?.week || 0,
              month: smsMetrics?.month || 0,
              lastMonth: smsMetrics?.lastMonth || 0,
            },
            clicks: {
              today: clickMetrics?.today || 0,
              yesterday: clickMetrics?.yesterday || 0,
              week: clickMetrics?.week || 0,
              month: clickMetrics?.month || 0,
              lastMonth: clickMetrics?.lastMonth || 0,
            },
            purchases: {
              today: conversionMetrics?.today || 0,
              yesterday: conversionMetrics?.yesterday || 0,
              week: conversionMetrics?.week || 0,
              month: conversionMetrics?.month || 0,
              lastMonth: conversionMetrics?.lastMonth || 0,
            },
            revenue: {
              today: revenueMetrics?.today || 0,
              yesterday: revenueMetrics?.yesterday || 0,
              week: revenueMetrics?.week || 0,
              month: revenueMetrics?.month || 0,
              lastMonth: revenueMetrics?.lastMonth || 0,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching SMS analytics:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <motion.div
      className="sms-section"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <div className="section-title">
        <h2>SMS Analytics</h2>
        <span className="material-symbols-outlined">mail</span>
      </div>
      <div className="sms-analytics-grid">
        <div className="sms-card">
          <h3>📨 Sent</h3>
          <p><strong>Today:</strong> <span>{smsData.sent.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{smsData.sent.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{smsData.sent.week}</span></p>
          <p><strong>Month:</strong> <span>{smsData.sent.month}</span></p>
          <p><strong>Last Month:</strong> <span>{smsData.sent.lastMonth}</span></p>
        </div>

        <div className="sms-card">
          <h3>👆 Link Clicks</h3>
          <p><strong>Today:</strong> <span>{smsData.clicks.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{smsData.clicks.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{smsData.clicks.week}</span></p>
          <p><strong>Month:</strong> <span>{smsData.clicks.month}</span></p>
          <p><strong>Last Month:</strong> <span>{smsData.clicks.lastMonth}</span></p>
        </div>

        <div className="sms-card">
          <h3>🛒 Purchases</h3>
          <p><strong>Today:</strong> <span>{smsData.purchases.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{smsData.purchases.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{smsData.purchases.week}</span></p>
          <p><strong>Month:</strong> <span>{smsData.purchases.month}</span></p>
          <p><strong>Last Month:</strong> <span>{smsData.purchases.lastMonth}</span></p>
        </div>

        <div className="sms-card">
          <h3>💰 Revenue (৳)</h3>
          <p><strong>Today:</strong> <span>{smsData.revenue.today}</span></p>
          <p><strong>Yesterday:</strong> <span>{smsData.revenue.yesterday}</span></p>
          <p><strong>Week:</strong> <span>{smsData.revenue.week}</span></p>
          <p><strong>Month:</strong> <span>{smsData.revenue.month}</span></p>
          <p><strong>Last Month:</strong> <span>{smsData.revenue.lastMonth}</span></p>
        </div>
      </div>
    </motion.div>
  );
}

export default SmsSection;
